export default class CourseTag {
  readonly id: number
  readonly name: String
  readonly courseCount: number

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.name = data.name
    this.courseCount = data.courseCount
  }
}
